module.exports = __webpack_public_path__ + "static/media/_CustomerInformation.53dbbfd2.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/CustomerInformation/_CustomerInformation.scss
// module id = 448
// module chunks = 0